/* tslint:disable */
/* eslint-disable */
/**
 * Coproperty API
 * MRI coproperties (the risk entity of the MRI branch) — creation, structural attributes, buildings, and attachment to the risk.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BuildingStanding } from './BuildingStanding';
import {
    BuildingStandingFromJSON,
    BuildingStandingFromJSONTyped,
    BuildingStandingToJSON,
    BuildingStandingToJSONTyped,
} from './BuildingStanding';

/**
 * Coproperty attributes only (identity, areas, terrain, altitude, natures). Buildings have their own command.
 * @export
 * @interface UpdateCopropertyCommand
 */
export interface UpdateCopropertyCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateCopropertyCommand
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCopropertyCommand
     */
    registrationNumber?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCopropertyCommand
     */
    builtMoreThan10YearsAgo?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateCopropertyCommand
     */
    area?: number | null;
    /**
     * Green space area in m² (pre-filled parcel − building footprint, broker-adjustable). Above 100 000 → not eligible.
     * @type {number}
     * @memberof UpdateCopropertyCommand
     */
    greenSpaceArea?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCopropertyCommand
     */
    above1500mAltitude?: boolean | null;
    /**
     * Fire station within 3 km or 30 mn — expected when above1500mAltitude (false → not eligible).
     * @type {boolean}
     * @memberof UpdateCopropertyCommand
     */
    fireStationWithin3Km?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCopropertyCommand
     */
    occupiedLessThan50Percent?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCopropertyCommand
     */
    natureHousing?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCopropertyCommand
     */
    natureOffices?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCopropertyCommand
     */
    natureShops?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCopropertyCommand
     */
    natureParking?: boolean;
    /**
     * Must stay below the total area (input validation, the update fails otherwise).
     * @type {number}
     * @memberof UpdateCopropertyCommand
     */
    commercialParkingArea?: number | null;
    /**
     * Must stay below the total area.
     * @type {number}
     * @memberof UpdateCopropertyCommand
     */
    shopsArea?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCopropertyCommand
     */
    shopType?: string | null;
    /**
     * Must stay below the total area.
     * @type {number}
     * @memberof UpdateCopropertyCommand
     */
    officesArea?: number | null;
    /**
     * Listed or registered on the city's buildings list — declarative, does not block the subscription.
     * @type {boolean}
     * @memberof UpdateCopropertyCommand
     */
    listedOrRegistered?: boolean | null;
    /**
     * Altitude of the coproperty point in metres (pre-filled by the terrain estimation, adjustable).
     * @type {number}
     * @memberof UpdateCopropertyCommand
     */
    altitudeMeters?: number | null;
    /**
     * Always set — Standard by default; drives the SMP.
     * @type {BuildingStanding}
     * @memberof UpdateCopropertyCommand
     */
    buildingStanding?: BuildingStanding;
}



/**
 * Check if a given object implements the UpdateCopropertyCommand interface.
 */
export function instanceOfUpdateCopropertyCommand(value: object): value is UpdateCopropertyCommand {
    return true;
}

export function UpdateCopropertyCommandFromJSON(json: any): UpdateCopropertyCommand {
    return UpdateCopropertyCommandFromJSONTyped(json, false);
}

export function UpdateCopropertyCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCopropertyCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'registrationNumber': json['registrationNumber'] == null ? undefined : json['registrationNumber'],
        'builtMoreThan10YearsAgo': json['builtMoreThan10YearsAgo'] == null ? undefined : json['builtMoreThan10YearsAgo'],
        'area': json['area'] == null ? undefined : json['area'],
        'greenSpaceArea': json['greenSpaceArea'] == null ? undefined : json['greenSpaceArea'],
        'above1500mAltitude': json['above1500mAltitude'] == null ? undefined : json['above1500mAltitude'],
        'fireStationWithin3Km': json['fireStationWithin3Km'] == null ? undefined : json['fireStationWithin3Km'],
        'occupiedLessThan50Percent': json['occupiedLessThan50Percent'] == null ? undefined : json['occupiedLessThan50Percent'],
        'natureHousing': json['natureHousing'] == null ? undefined : json['natureHousing'],
        'natureOffices': json['natureOffices'] == null ? undefined : json['natureOffices'],
        'natureShops': json['natureShops'] == null ? undefined : json['natureShops'],
        'natureParking': json['natureParking'] == null ? undefined : json['natureParking'],
        'commercialParkingArea': json['commercialParkingArea'] == null ? undefined : json['commercialParkingArea'],
        'shopsArea': json['shopsArea'] == null ? undefined : json['shopsArea'],
        'shopType': json['shopType'] == null ? undefined : json['shopType'],
        'officesArea': json['officesArea'] == null ? undefined : json['officesArea'],
        'listedOrRegistered': json['listedOrRegistered'] == null ? undefined : json['listedOrRegistered'],
        'altitudeMeters': json['altitudeMeters'] == null ? undefined : json['altitudeMeters'],
        'buildingStanding': json['buildingStanding'] == null ? undefined : BuildingStandingFromJSON(json['buildingStanding']),
    };
}

export function UpdateCopropertyCommandToJSON(json: any): UpdateCopropertyCommand {
    return UpdateCopropertyCommandToJSONTyped(json, false);
}

export function UpdateCopropertyCommandToJSONTyped(value?: UpdateCopropertyCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'registrationNumber': value['registrationNumber'],
        'builtMoreThan10YearsAgo': value['builtMoreThan10YearsAgo'],
        'area': value['area'],
        'greenSpaceArea': value['greenSpaceArea'],
        'above1500mAltitude': value['above1500mAltitude'],
        'fireStationWithin3Km': value['fireStationWithin3Km'],
        'occupiedLessThan50Percent': value['occupiedLessThan50Percent'],
        'natureHousing': value['natureHousing'],
        'natureOffices': value['natureOffices'],
        'natureShops': value['natureShops'],
        'natureParking': value['natureParking'],
        'commercialParkingArea': value['commercialParkingArea'],
        'shopsArea': value['shopsArea'],
        'shopType': value['shopType'],
        'officesArea': value['officesArea'],
        'listedOrRegistered': value['listedOrRegistered'],
        'altitudeMeters': value['altitudeMeters'],
        'buildingStanding': BuildingStandingToJSON(value['buildingStanding']),
    };
}

